import React from 'react';
import LegalDocument from "./LegalDocument";
// Single source of truth: edit the JSON, not this file or
// server/public/termsofuse.html (generated by scripts/buildLegalHtml.js).
import terms from "../data/legal/termsOfUse.json";

function TermsOfUse({ hideFooter = false }) {
  return <LegalDocument doc={terms} className="terms-of-use-container" hideFooter={hideFooter} />;
}

export default TermsOfUse;
